var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSector = function SvgSector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sector_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sector_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "sector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0c1457",
    d: "M14.532 14H5.47a.47.47 0 0 1-.45-.5L5 5.492A.48.48 0 0 1 5.47 5h2.187a.48.48 0 0 1 .469.492v4.03L10.843 7.7a.45.45 0 0 1 .25-.077.483.483 0 0 1 .47.493v1.4L14.3 7.7a.44.44 0 0 1 .246-.077.476.476 0 0 1 .454.497v5.38a.486.486 0 0 1-.468.5m-2.791-3v.893h.851V11ZM9.86 11v.893h.851V11Zm-1.89 0v.893h.85V11Z",
    "data-name": "Subtraction 3"
  })))));
};
export default SvgSector;